require.register("thesaurus/controllers/detailsCtrl", function(exports, require, module){
  $0
  
});

